import { ResetPasswordState } from 'User/types/resetPassword';


const initialState: ResetPasswordState = {
  password: '',
  repeatPassword: '',
  step: 1,
  mobileNumber: '',
};

export default initialState;
